import { render, staticRenderFns } from "./purchaseReturn.vue?vue&type=template&id=b9fac13e&scoped=true&"
import script from "./purchaseReturn.vue?vue&type=script&lang=js&"
export * from "./purchaseReturn.vue?vue&type=script&lang=js&"
import style0 from "./purchaseReturn.vue?vue&type=style&index=0&id=b9fac13e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fac13e",
  null
  
)

export default component.exports